export function HqMark({ className = 'h-8 w-8' }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <rect width='32' height='32' rx='8' className='fill-hq-sage' />
      <path
        d='M8 14.2 16 8.4l8 5.8V23a1.6 1.6 0 0 1-1.6 1.6h-4.2v-5.2h-4.4V24.6H9.6A1.6 1.6 0 0 1 8 23V14.2Z'
        className='fill-hq-cream'
      />
    </svg>
  );
}
